import * as translator from "../../../../../utils/translator";

type Props = {
  language: string | undefined;
};

const LocationDetectingState: React.FC<Props> = ({ language }) => {
  return (
    <div className="flex flex-col items-center justify-center px-3 py-10 gap-4 flex-1">
      <div className="w-9 h-9 border-[3px] border-[#e0e0e0] border-t-[#269c6e] rounded-full animate-spin" />
      <p className="font-roboto text-sm text-[#747474] text-center m-0">
        {translator.translate(language, "shipping", "AddNewAddressModal/detecting_location") || "Detecting your location..."}
      </p>
    </div>
  );
};

export default LocationDetectingState;
